module.exports = __webpack_public_path__ + "img/mediagirl3_2024.34588eda.jpg";